import React, { useState, useContext } from 'react';
import { useNavigate } from 'react-router-dom';
import api from '../utils/api';
import './styles/InventoryListPage.css';
import AuthContext from '../context/AuthContext';

const ResetPasswordPage = () => {
    const { user } = useContext(AuthContext);
    const [currentPassword, setCurrentPassword] = useState('');
    const [newPassword, setNewPassword] = useState('');
    const [newPassword2, setNewPassword2] = useState('');
    const navigate = useNavigate();

    

    const handleSubmit = async (e) => {
        e.preventDefault();

        if (newPassword !== newPassword2){
            alert('New password must be the same!');
            return;
        }
        
        try {
            const response = await api.post('/auth/resetPassword', 
                { 
                    data: {
                        username: user.username, 
                        password: currentPassword, 
                        newPassword: newPassword
                    }
                });

            console.log('Reset password successfully:', response.message);
            navigate('/success', { state: { message: response.message } });    
        } catch (error) {
            alert('Reset password failed!'+ error);
            console.error('Error adding inventory:', error);
            navigate('/error', { state: { message: 'Please ask to administrator!' } });
        }
    };
    
    return (
        <div className="inventory-page">           
            <div className="page-title">Reset Password</div>
            <form onSubmit={handleSubmit}>
                <div className="search-container">
                    <table>
                        <tbody>
                            <tr>
                                <td>
                                    <label>Current Password</label>
                                </td>
                                <td>
                                    <input
                                        type="password"
                                        name="currentPassword"
                                        value={currentPassword}
                                        onChange={(e) => setCurrentPassword(e.target.value)}
                                    />
                                </td>
                            </tr>
                            <tr>
                                <td>
                                    <label>Enter New Password</label>
                                </td>
                                <td>
                                    <input
                                        type="password"
                                        name="newPassword"
                                        value={newPassword}
                                        onChange={(e) => setNewPassword(e.target.value)}
                                    />
                                </td>
                            </tr><tr>
                                <td>
                                    <label>Re-Enter New Password</label>
                                </td>
                                <td>
                                    <input
                                        type="password"
                                        name="newPassword2"
                                        value={newPassword2}
                                        onChange={(e) => setNewPassword2(e.target.value)}
                                    />
                                </td>
                            </tr>
                            <tr>
                                <td colSpan="2">
                                <button type="submit">Reset Password</button>  
                                </td>
                            </tr>
                        </tbody>
                    </table>
                </div>
            </form>
        </div>
    );
};

export default ResetPasswordPage;
